import React, {Component} from 'react';
import PropTypes from "prop-types";
import PageLinksContainer from "../../utils/PageLinksContainer";

class AnalysisContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.translate = this.props.baseData.translate;

    }

    getPageLinks() {

        const links = [
            {
                header: this.translate('machines'),
                src: require('../../img/nav/machines-default.svg').default,
                link: 'machines',
            },
            {
                header: this.translate('reports'),
                src: require('../../img/nav/reports-default.svg').default,
                link: 'reports',
            },
            {
                header: this.translate('designs'),
                src: require('../../img/nav/patterns-default.svg').default,
                link: 'designs',
            },
            {
                header: this.translate('alarms'),
                src: require('../../img/nav/sidenav/web/alarms-default.svg').default,
                link: 'alarms',
            },
        ];

        if (this.props.baseData.checkUserRole('superadmin') || this.props.baseData.checkUserRole('zskadmin') || this.props.baseData.checkUserRole('companyadmin')) {
            links.push({
                header: this.translate('setup'),
                src: require('../../img/nav/setup-default.svg').default,
                link: 'setup',
            });
        }

        return links;

    }

    render() {

        const pageLinks = this.getPageLinks();

        return (
            <div className={"AnalysisContainer"}>
                <nav>
                    <h1>{this.translate('analysis')}</h1>
                </nav>

                <PageLinksContainer
                    pageLinks={pageLinks}
                    pageNavigation={this.props.baseData.pageNavigation}
                />
            </div>
        );

    }

}

export default AnalysisContainer;